export default __webpack_public_path__ + "static/case-logo-1-dbe2f938196f5bf5064ac686daf95b0d.webp";